module.exports = __webpack_public_path__ + "static/45-0f6bbb82bec7aa1fa5dfd7529c83e16c.png";